import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export enum OttopilotEventArchiveRuleKind {
    requiresEmptyColumn = "77b6d245-0857-43ce-98dc-3d896d666fef",
    requiresEqualsColumnValue = "e2f1fd5e-36cb-40f3-814f-65d625e3350f",
    requiresNotEqualsColumnValue = "c6ec06bf-f48d-4c1a-b574-81e6070354bb",
}

export type OttopilotEventArchiveRule =
    | {
          kind: OttopilotEventArchiveRuleKind.requiresEmptyColumn;
          columnId: Uuid;
          disabledReason: string;
      }
    | {
          kind: OttopilotEventArchiveRuleKind.requiresEqualsColumnValue;
          columnId: Uuid;
          expectedValue: unknown;
          disabledReason: string;
      }
    | {
          kind: OttopilotEventArchiveRuleKind.requiresNotEqualsColumnValue;
          columnId: Uuid;
          expectedValue: unknown;
          disabledReason: string;
      };

export type OttopilotEventArchiveConfig = {
    rules: Array<OttopilotEventArchiveRule>;
};

const eventArchiveRuleValidator: zod.ZodType<OttopilotEventArchiveRule> = zod.discriminatedUnion("kind", [
    zod.strictObject({
        kind: zod.literal(OttopilotEventArchiveRuleKind.requiresEmptyColumn),
        columnId: uuidZodValidator,
        disabledReason: zod.string(),
    }),
    zod.strictObject({
        kind: zod.literal(OttopilotEventArchiveRuleKind.requiresEqualsColumnValue),
        columnId: uuidZodValidator,
        expectedValue: zod.unknown(),
        disabledReason: zod.string(),
    }),
    zod.strictObject({
        kind: zod.literal(OttopilotEventArchiveRuleKind.requiresNotEqualsColumnValue),
        columnId: uuidZodValidator,
        expectedValue: zod.unknown(),
        disabledReason: zod.string(),
    }),
]);

export const ottopilotEventArchiveConfigValidator: zod.ZodType<OttopilotEventArchiveConfig> = zod.strictObject({
    rules: eventArchiveRuleValidator.array(),
});
